<template>
  <div class="text-xs-center">
    <v-dialog fullscreen v-model="dialog">
      <v-card>
        <v-toolbar color="primary" dark tabs>
          <v-toolbar-title>{{titleAction}}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click="cancel()" dark icon>
            <v-icon>close</v-icon>
          </v-btn>

          <v-tabs color="primary" slider-color="blue" slot="extension" v-model="tabActive" centered>
            <v-tab>{{$t('information')}}</v-tab>
            <v-tab :disabled="action==='create'">{{$tc('pitch',2)}}</v-tab>
          </v-tabs>
        </v-toolbar>
        <v-card-text>
          <v-tabs-items v-model="tabActive">
            <v-tab-item ripple>
              <tab-informacion
                @close="close()"
                :edit-external="edit&&!isTrainerOrEntity"
                :status="dialog"
                :action="action"
              />
            </v-tab-item>

            <v-tab-item ripple>
              <tab-pitches :edit-external="edit"/>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import tabPitches from './tabPitches'
import tabInformacion from './tabInformation'

export default {
  name: 'formManager',
  components: {
    tabInformacion,
    tabPitches
  },
  props: {
    modal: {
      type: Boolean,
      required: true
    },
    edit: {
      type: Boolean,
      required: false,
      default: true
    },
    action: {
      type: String,
      required: false,
      default: 'view'
    }
  },
  data() {
    return {
      tabActive: null
    }
  },
  computed: {
    ...mapState({
      stadium: state => state.stadiums.stadiumSelected,
      authUser: state => state.authentication.user
    }),
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) {
          this.tabActive = 0
          this.$emit('close')
        }
      }
    },
    titleAction() {
      switch (this.action) {
        case 'create':
          return this.$t('newModel', { field: this.$tc('stadium') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('stadium') })
        case 'remove':
          return this.$t('deleteModel', { field: this.$tc('stadium') })
      }
      return ''
    },
    isTrainerOrEntity() {
      let isTrainerOrEntity = false
      let isTeamManager = !this.isAdmin && (this.hasRole('teams') || this.hasRole('entities'))
      if (isTeamManager && this.authUser.entities) {
        isTrainerOrEntity = this.authUser.entities.some(entity =>
          entity.stadiumId.includes(this.stadium._id)
        )
      }
      return isTrainerOrEntity
    }
  },
  methods: {
    ...mapActions({
      reset: 'stadiums/setClearOne'
    }),
    cancel() {
      this.dialog = false
      this.reset()
    },
    close() {
      this.dialog = false
      this.reset()
    }
  }
}
</script>
